import { render, staticRenderFns } from "./regionActivityInfo.vue?vue&type=template&id=e2ebeba4&scoped=true"
import script from "./regionActivityInfo.vue?vue&type=script&lang=js"
export * from "./regionActivityInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2ebeba4",
  null
  
)

export default component.exports